var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectTypeBiodiversity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 4.66645H10.6732M2.26654 11.9998H7.99987C9.41436 11.9998 10.7709 11.4379 11.7711 10.4377C12.7713 9.43749 13.3332 8.08093 13.3332 6.66645V4.66645C13.3347 4.09839 13.1548 3.54469 12.8196 3.08604C12.4844 2.62739 12.0116 2.28775 11.4699 2.11662C10.9282 1.94549 10.3461 1.9518 9.80823 2.13465C9.2704 2.31749 8.80501 2.6673 8.47987 3.13311L1.33321 13.3331",
    stroke: "#2A4234",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 4.66638L14.6665 4.99972L13.3332 5.33305M6.66652 11.9997V13.9997M9.33319 11.833V13.9997M4.66652 11.9997C5.4886 11.9997 6.2907 11.7463 6.96367 11.2742C7.63664 10.802 8.14779 10.134 8.42756 9.36099C8.70733 8.58798 8.74213 7.74755 8.52723 6.95405C8.31232 6.16056 7.85815 5.45255 7.22652 4.92638",
    stroke: "#2A4234",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectTypeBiodiversity);
export default __webpack_public_path__ + "static/media/project-type-biodiversity.799f706ace3edbc9cc18032881de1f34.svg";
export { ForwardRef as ReactComponent };